import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import moment from 'moment';
import { getQueryKeys } from './queryKeys';
import { defaultRequestDateMode } from '../../../constants/requests.constants';

const getHousingStockRequests = async ({ houseId, addressId }) => {
  return await request.get(
    `/Request`,
    {
      filterDateMode: defaultRequestDateMode,
      fromDate: '2020-01-01T00:00:00Z',
      toDate: moment().set({ hour: 23, minute: 59, second: 59 }).utc().format(),
      houses: [houseId],
      addresses: [addressId],
    },
    'При загрузке заявок произошла ошибка',
    []
  );
};

const useHousingStockRequests = ({ houseId, addressId }, options = {}) =>
  useQuery(
    getQueryKeys.housingStockRequests(houseId, addressId),
    () => getHousingStockRequests({ houseId, addressId }),
    {
      placeholderData: [],
      enabled: Boolean(houseId) || Boolean(addressId),
      ...options,
    }
  );

export default useHousingStockRequests;
